<template>
  <div class="absolute top-0 z-50  w-full h-full flex items-center justify-center">
    
    <div class=" w-full h-full bg-gray-500 blur-lg opacity-70"></div>

    <div class=" orderPanel  absolute flex flex-col m-auto w-10/12 md:w-4/5 md:max-w-md rounded bg-slate-200">
      <div>
        <div class="flex border-b border-blue-400 p-2">
          <div class="ml-auto font-bold text-xl">All Requests</div>
          <div v-on:click="close()" class=" ml-auto w-8 h-8 bg-slate-100 border-slate-300 rounded-full flex active:scale-75 hover:scale-105">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class=" w-7 h-7 m-auto">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
          </div>
        </div>
      </div>
      
      
      
      <div class=" flex flex-col overflow-y-auto mt-2 w-full text-sm">
        <div v-for="(data,i) in data" :key="i" class=" w-full p-4">
          <div class="flex flex-col w-full h-full rounded bg-gray-100 p-4">
            <div class=" flex flex-col h-fit w-full">
            <div class=""> {{ data.phone_brand }} {{ data.phone_model }}  </div>  
            <!-- <button class=" bg-blue-400 text-white font-medium cursor-pointer shadow px-2 py-1 ml-auto" 
            v-on:click="showPreview(true,data.image_preview_path)"> Preview</button> -->
          </div>

          <div class="mt-2 flex flex-row">
            <div class=" ">Request Number: {{ data.id }}</div>
            <!-- <div class=" font-medium ml-auto">K {{ data.amount }}</div>             -->
          </div>

          <div class="mt-2 flex flex-row text-sm font">
            <div class=" flex flex-col">
              <div class=" ">Request Status: </div>
              <div class=" font-medium">{{ data.request_status }}</div>  
            </div>
            <div class=" flex flex-col ml-auto">
              <!-- <div class=" ">Payment Status: </div> -->
              <!-- <div class=" font-medium ml-auto">{{ data.payment_status }}</div>   -->

              <button v-on:click="ChangeStatus(data.id, i)" class=" bg-yellow-200  text-gray-600 font-medium cursor-pointer shadow px-2 py-1 ml-auto"> Change Status</button>
            
            </div>
            
          </div>
            
          </div>         
          
        </div>

      </div>
    
    </div>

  

    <div v-if="previewCase" class=" absolute top-0 z-50  w-full h-full flex items-center justify-center">
    
    <div class=" w-full h-full bg-gray-500 blur-lg opacity-70"></div>
    <div class=" absolute flex flex-col m-auto text-xl font-bold w-10/12 md:w-96 rounded bg-white p-6">
      
      
      <img v-if="ImageData" alt="logo" class="" :src=ImageData>

        <button
                class=" mt-4 self-center bg-gray-200 border-gray-300 border font-medium text-gray-600 cursor-pointer shadow py-2 px-4 mx-auto"
                @click="showPreview(false)"
              >
                Close
        </button>
        <!-- <button
                class=" mt-4 self-center bg-gray-200 border-gray-300 border font-medium text-gray-600 cursor-pointer shadow py-2 px-4 mx-auto"
                @click="ShowPayerMsgBox(false)"
              >
                Save Image
        </button> -->

      </div>
      
    </div>

    <setRequestStatus v-if="showSetRequestStatus"></setRequestStatus>
  
  </div>
  
</template>

<script>
// @ is an alias to /src

import axios from "axios";
import { mapGetters, mapMutations,mapActions } from "vuex";
import SetRequestStatus from "@/views/admin/SetRequestStatusView.vue";

export default {
  name: 'OrderPage',
  components: {
    setRequestStatus: SetRequestStatus,
  },
  data () {
       return{
        details:'',
        amount:'',
        status:'',
        order_date:'',
        data:[],
        pageNumber: 1,
        PageSize: 100,
        previewCase: false,
        ImageData:null,
        showSetRequestStatus: false,
        selectedRequest:null,
        selectedRequestIndex:null,
        BackendUrl: "https://labsapi.packymstechnology.com"
       }
      },

      computed: {
      ...mapGetters(["GET_SCREENSHOT"]),

    },
  methods:{
    ...mapMutations([
        "REGENERATE_GEOMETRY", 
        "LOADED_STL",
        "SET_COLOR",
        "SET_SCREENSHOT_POSITION"      
      ]),
      ...mapActions(["REGENERATE_GEOMETRY","LOAD_STL","TAKE_SCREENSHOT"]),
    close(){
      this.$parent.showAllRequests(false);
    },
    showPreview(show,img){
      if(show){
      //   this.SET_SCREENSHOT_POSITION()
      // this.$parent.showLoading(true)
      // this.TAKE_SCREENSHOT().then(() => {
      //       setTimeout(()=>{
      //         // this.LOADED_STL()
      //         this.ImageData = this.GET_SCREENSHOT
      //         this.previewCase = true
      //         this.$parent.showLoading(false)
      //       },1000)
      //     })
        this.previewCase = true
        this.ImageData = img
      }else{
        this.previewCase = false
      }
      
    },

    async loadOrders(){
      this.$parent.showLoading(true)
      let dev = process.env.VUE_APP_DEVELOPMENT;    
    if (dev == "true") {
      console.log("is in dev mode")
      this.BackendUrl = "";
    }
         
      try {
        let result = await axios.get(this.BackendUrl + "/admin/all_request_cover", {
            headers:{
            Authorization : `Bearer ${JSON.parse(localStorage.getItem('account')).access_token}`
          }
          });
          if(result.status == 200){
            // alert(" Order fetched")
            this.data = result.data
            // this.close();
  
          } else {
            alert("there was an error with placing Order")
          }
      } catch (error) {
        const code = error.response.status
        
          if(code == 401){
            this.close();
            this.$parent.setMessageBox("Please LogIn Again", "warning")
            this.$parent.showLogin(true);
          } else{
            this.$parent.setMessageBox("Something went wrong, Please check your internet connection or try again later", "error")
          }
      }
     
  
          
          this.$parent.showLoading(false)
    },

    updateAndClose(valueData){
      this.data[this.selectedRequestIndex].request_status = valueData;
      this.showUpdateRequestStatus(false);
    }, 

    showUpdateRequestStatus(show){
      this.showSetRequestStatus = show;
    },
    ChangeStatus(id, index){
      this.selectedRequest = id;
      this.selectedRequestIndex = index;
      this.showUpdateRequestStatus(true);
    },
    setMessageBox(message,type){
      this.$parent.setMessageBox(message, type)
    }

  },
  mounted(){
    let user = localStorage.getItem('account');
    if(user) {
      this.loadOrders()
    }
  }
  
}
</script>
<style scoped>
.orderPanel{
max-height: 85%;
}
</style>
